import React from 'react';
// import LanguageDropdown from './LanguageDropdown';
import BackButton from './BackButton';
import './Login.css';
import shelegLogin from '../api/shelegLogin';
import langConf from "../js/lang";

class Login extends React.Component {

    handleLoginClick = async (event) => {
        event.preventDefault();
        if (await this.validateLogin()) {
            await this.props.saveNewCart();
            this.props.changePaymentMode('payment');
        }
    };

    handleForgotPasswordClick = (event) => {
        event.preventDefault();
        this.props.changePaymentMode('forgotPassword');
    };

    handleLogoClick = (event) => {
        event.preventDefault();
    };

    handleKeyDown = async (e) => {
        //console.log('key: ', e.key);
        if (e.key === 'Enter') {
            if (await this.validateLogin()) {
                //this.props.changeScreen('items');
                await this.props.saveNewCart();
                this.props.changePaymentMode('payment');
            }
        }
    };

    validateLogin = async () => {
        let lang = this.props.lang;
        let username = document.querySelector('#username').value;
        let password = document.querySelector('#password').value;

        if (username === '' && password === '') {
            window.alert(langConf[lang].emptyLogin);
            return false;
        }
        else if (username === '') {
            window.alert(langConf[lang].emptyUsername);
            return false;
        }
        else if (password === '') {
            window.alert(langConf[lang].emptyPassword);
            return false;
        }

        //console.log('username: ', username, ' password: ', password);

        // Request..
        const response = await shelegLogin.get(`CheckPassword/${this.props.sessionId}/${username}/${password}`);
        //console.log('login response: ', response);
        if (response.data.rslt) {
            localStorage.setItem('username', username);
            localStorage.setItem('password', password);
            localStorage.setItem('t', response.data.objType);
            localStorage.setItem('n', response.data.objNo);
            //console.log('response.data.objType: ', response.data.objType);
            //console.log('response.data.objNo: ', response.data.objNo);
            await this.props.changeObjectType(response.data.objType);
            await this.props.changeObjectNo(response.data.objNo);
            return true;
        } else {
            window.alert(langConf[lang].failedLogin);
            return false;
        }
    };

    render() {
        let lang = this.props.lang;
        //let logoURL = lang === 'hebrew' ? this.props.vendorData.logoUrlHeb : this.props.vendorData.logoUrlEng;
        let currentURL = this.props.currentURL;
        let isDisabled = false;
        return (
            <div className='col-12 panel panel-info' style={this.props.visible === false ? { display: 'none' } : {}}>
                <div className='panel-heading'>{langConf[lang].loginHere}</div>
                <div className='col-4 col-lg-4 col-md-3 col-xs-0 col-sm-0'></div>
                <div className='col-4 col-lg-4 col-md-6 col-xs-12 col-sm-12'>
                    <div className="col-12">
                        <div className={`field username ${lang} signup-field`}>
                            <label className={`label username ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].username}</label>
                            <input id='username' type='text' defaultValue={this.props.existingUsername} className={`form-control input-lg login-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="0" style={{ textAlign: 'right' }}></input>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className={`field password ${lang} signup-field`}>
                            <label className={`label password ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].password}</label>
                            <input id='password' type='password' className={`form-control input-lg login-field ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} tabIndex="10" style={{ textAlign: 'right' }}></input>
                        </div>
                    </div>
                </div>
                <div className='col-4 col-lg-4 col-md-3 col-xs-0 col-sm-0'></div>
                <div className="col-12 col-xs-12">
                    <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{}}><b>{langConf[lang].forgotPassword}</b></a>
                </div>
                <div className='col-2 col-xs-0 col-sm-0'></div>
                <div className='col-8 col-xs-12 col-sm-12'>
                    <div className="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6">
                        <BackButton
                            //Globals
                            lang={lang}
                            currentURL={this.props.currentURL}
                            //Methods
                            onClick={(event) => { event.preventDefault(); this.props.changePaymentMode('signup'); }}
                        />
                    </div>
                    <div className="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6">
                        <a href={currentURL} className={`btn btn-success btn-block btn-lg ${isDisabled} login-button ${lang}`} onClick={this.handleLoginClick} style={{}}>{langConf[lang].login}</a>
                    </div>
                </div>
                <div className='col-2'></div>
            </div>
        );

    }
}

export default Login;



// render(){
//     let lang = this.props.lang;
//     let logoURL = lang === 'hebrew' ? this.props.vendorData.logoUrlHeb : this.props.vendorData.logoUrlEng;
//     let currentURL = this.props.currentURL;
//     let isDisabled = false;

//     // Default sizes
//     let loginFieldsMarginRight = '15%';
//     let loginFieldsMarginLeft = '15%';
//     let fieldsSize = 'big';
//     let fieldsWidth = '12.6‬%';
//     let fieldWidth = '100%';
//     //console.log('window.innerWidth: ', window.innerWidth);
//     if (window.innerWidth >= 0 && window.innerWidth <= 480) {// Small phones: form 0px to 480px 
//         // loginFieldsMarginRight = '17%';
//         // loginFieldsMarginLeft = '17%';
//         fieldsSize = 'massive';
//         fieldsWidth = '100‬%';
//         fieldWidth = '100%';
//     }
//     else if (window.innerWidth >= 481 && window.innerWidth <= 767) {// Small phones to small tablets: form 481px to 767px 
//         // loginFieldsMarginRight = '28%';
//         // loginFieldsMarginLeft = '28%';
//     }
//     else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {// Small tablets to big tablets: form 768px to 1023px
//         // loginFieldsMarginRight = '35%';
//         // loginFieldsMarginLeft = '35%';
//     }
//     else if (window.innerWidth <= 1200) {// Big tablets to 1200px (widths smaller than the 1140px row) 
//         // loginFieldsMarginRight = '38.6%';
//         // loginFieldsMarginLeft = '38.6%';
//     }



//     if (window.innerWidth >= 0 && window.innerWidth <= 480) {// Small phones: form 0px to 480px 
//         return (
//             <div  style={this.props.visible === false ? {display: 'none'} : {}}>
//                 {/* <LanguageDropdown 
//                     lang={lang} 
//                     // Methods 
//                     changeLanguage={this.props.changeLanguage}
//                 /> */}
//                 {/* <div className={`login-fields ${lang}`} style={{marginRight: `${loginFieldsMarginRight}`, marginLeft: `${loginFieldsMarginLeft}`}}> */}
//                 <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}>
//                     <a className="ui logo icon image" href={currentURL} onClick={this.handleLogoClick}>
//                         <img src={logoURL} alt="logo"/>
//                     </a>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', backgroundColor: 'black', borderRadius: '50px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                     {/* <a href={currentURL} className={`ui ${isDisabled} blue button login-signup-button ${lang}`} onClick={this.handleSignupClick} style={{display: 'inline-block'}}>{langConf[lang].signup}</a> */}
//                     <a href={currentURL} className="ui olive button" onClick={this.handleBackToSignup}>{langConf[lang].back}</a>
//                     <a href={currentURL} className={`ui ${isDisabled} blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', float: 'left'}}>{langConf[lang].login}</a>
//                 </div>
//             </div>
//         );
//     }
//     else if (window.innerWidth >= 481 && window.innerWidth <= 767) {// Small phones to small tablets: form 481px to 767px 
//         return (
//             <div  style={this.props.visible === false ? {display: 'none'} : {}}>
//                 {/* <LanguageDropdown 
//                     lang={lang} 
//                     // Methods 
//                     changeLanguage={this.props.changeLanguage}
//                 /> */}
//                 {/* <div className={`login-fields ${lang}`} style={{marginRight: `${loginFieldsMarginRight}`, marginLeft: `${loginFieldsMarginLeft}`}}> */}
//                 <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}>
//                     <a className="ui logo icon image" href={currentURL} onClick={this.handleLogoClick}>
//                         <img src={logoURL} alt="logo"/>
//                     </a>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', backgroundColor: 'black', borderRadius: '50px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                     {/* <a href={currentURL} className={`ui ${isDisabled} blue button login-signup-button ${lang}`} onClick={this.handleSignupClick} style={{display: 'inline-block'}}>{langConf[lang].signup}</a> */}
//                     <a href={currentURL} className="ui olive button" onClick={this.handleBackToSignup}>{langConf[lang].back}</a>
//                     <a href={currentURL} className={`ui ${isDisabled} blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', float: 'left'}}>{langConf[lang].login}</a>
//                 </div>
//             </div>
//         );
//     }
//     else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {// Small tablets to big tablets: form 768px to 1023px
//         return (
//             <div style={this.props.visible === false ? {display: 'none'} : {}}>
//                 {/* <LanguageDropdown 
//                     lang={lang} 
//                     // Methods 
//                     changeLanguage={this.props.changeLanguage}
//                 /> */}
//                 {/* <div className={`login-fields ${lang}`} style={{marginRight: `${loginFieldsMarginRight}`, marginLeft: `${loginFieldsMarginLeft}`}}> */}
//                 <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}>
//                     <a className="ui logo icon image" href={currentURL} onClick={this.handleLogoClick}>
//                         <img src={logoURL} alt="logo"/>
//                     </a>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                         <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                     </div>
//                     <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', backgroundColor: 'black', borderRadius: '50px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                     {/* <a href={currentURL} className={`ui ${isDisabled} blue button login-signup-button ${lang}`} onClick={this.handleSignupClick} style={{display: 'inline-block'}}>{langConf[lang].signup}</a> */}
//                     <a href={currentURL} className="ui olive button" onClick={this.handleBackToSignup}>{langConf[lang].back}</a>
//                     <a href={currentURL} className={`ui ${isDisabled} blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', float: 'left'}}>{langConf[lang].login}</a>
//                 </div>
//             </div>
//         );
//     }
//     else if (window.innerWidth <= 1200) {// Big tablets to 1200px (widths smaller than the 1140px row) 
//         return (
//         <div style={this.props.visible === false ? {display: 'none'} : {}}>
//             {/* <LanguageDropdown 
//                 lang={lang} 
//                 // Methods 
//                 changeLanguage={this.props.changeLanguage}
//             /> */}
//             {/* <div className={`login-fields ${lang}`} style={{marginRight: `${loginFieldsMarginRight}`, marginLeft: `${loginFieldsMarginLeft}`}}> */}
//             <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}>
//                 <a className="ui logo icon image" href={currentURL} onClick={this.handleLogoClick}>
//                     <img src={logoURL} alt="logo"/>
//                 </a>
//                 <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                     <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                 </div>
//                 <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                     <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                 </div>
//                 <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', backgroundColor: 'black', borderRadius: '50px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                 {/* <a href={currentURL} className={`ui ${isDisabled} blue button login-signup-button ${lang}`} onClick={this.handleSignupClick} style={{display: 'inline-block'}}>{langConf[lang].signup}</a> */}
//                 <a href={currentURL} className="ui olive button" onClick={this.handleBackToSignup}>{langConf[lang].back}</a>
//                 <a href={currentURL} className={`ui ${isDisabled} blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', float: 'left'}}>{langConf[lang].login}</a>
//             </div>
//         </div>
//     );
//     }
//     else return (
//         <div style={this.props.visible === false ? {display: 'none'} : {}}>
//             {/* <LanguageDropdown 
//                 lang={lang} 
//                 // Methods 
//                 changeLanguage={this.props.changeLanguage}
//             /> */}
//             <div className={`login-fields ${lang}`} style={{marginRight: `${loginFieldsMarginRight}`, marginLeft: `${loginFieldsMarginLeft}`}}>
//             {/* <div className={`login-fields ${lang}`} style={{width: `${fieldsWidth}`}}> */}
//                 {/* <a className="ui logo icon image" href={currentURL} onClick={this.handleLogoClick}>
//                     <img src={logoURL} alt="logo"/>
//                 </a> */}
//                 <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                     <input type="text" id="username" className={`login-field ${lang}`} placeholder={langConf[lang].username} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                 </div>
//                 <div className={`ui input ${fieldsSize} login-field ${lang}`} style={{width: `${fieldWidth}`}}>
//                     <input type="password" id="password" className={`login-field ${lang}`} placeholder={langConf[lang].password} onKeyDown={this.handleKeyDown} style={{width: `${fieldWidth}`}}/>
//                 </div>
//                 <a href={currentURL} onClick={this.handleForgotPasswordClick} style={{display: 'block', paddingBottom: '5px', borderRadius: '50px', textAlign: 'center'}}><b>{langConf[lang].forgotPassword}</b></a>
//                 {/* <a href={currentURL} className={`ui ${isDisabled} blue button login-signup-button ${lang}`} onClick={this.handleSignupClick} style={{display: 'inline-block', marginRight: '0px'}}>{langConf[lang].signup}</a> */}
//                 <a href={currentURL} className="ui olive button" onClick={this.handleBackToSignup}>{langConf[lang].back}</a>
//                 <a href={currentURL} className={`ui ${isDisabled} blue button login-button ${lang}`} onClick={this.handleLoginClick} style={{display: 'inline-block', marginRight: '0px', float: 'left'}}>{langConf[lang].login}</a>
//             </div>
//         </div>
//     );
// }